import baseProps from './ChoosePlacementForButtonDropdownDataProvider.props';

export default {
	...baseProps,
	placements: { type: Array },
	service: { type: Object },
};
